import React from 'react';
import {view, Icon} from '@sail/ui';
import {warningCircle, info} from '@sail/icons/react/Icon';
import {COLORS} from 'src/v2/util/color';
import {Text} from 'src/v2/components/common/Text';

type BannerVariant = 'error' | 'warning' | 'info';

interface BannerProps {
  message: React.ReactNode;
  variant?: BannerVariant;
}

const variantConfig = {
  error: {
    icon: warningCircle,
    backgroundColor: COLORS.errorBackground,
    textColor: COLORS.textPrimary,
    iconColor: COLORS.communicationCritical,
  },
  warning: {
    icon: warningCircle,
    backgroundColor: COLORS.warningBackground,
    textColor: COLORS.textPrimary,
    iconColor: COLORS.communicationWarning,
  },
  info: {
    icon: info,
    backgroundColor: COLORS.infoBackground,
    textColor: COLORS.textPrimary,
    iconColor: COLORS.communicationInfo,
  },
};

export const Banner: React.FC<BannerProps> = ({message, variant = 'error'}) => {
  const config = variantConfig[variant];

  return (
    <view.div
      css={{
        stack: 'x',
        padding: 'space.150',
        borderRadius: 'small',
        backgroundColor: config.backgroundColor,
        alignItems: 'center',
        gap: 'space.150',
      }}
    >
      <Icon
        icon={config.icon}
        css={{
          color: config.iconColor,
          flexShrink: 0,
          height: 'space.150',
          width: 'space.150',
        }}
      />

      <Text type="caption" css={{color: config.textColor}}>
        {message}
      </Text>
    </view.div>
  );
};
